/* ==========================================================================
   PDP Saum: Info-Popup zu den drei Saumarten
   Leinenweberei Hoffmann, 01.09.2026

   HOFFMANN 01.09.2026: Bei Tischdecken, Tischlaeufern und Servietten waehlt der
   Kunde die Variantenoption "Saum". Die drei Werte (Schmaler Saum + Briefecke,
   Rahmensaum, Rahmensaum mit Hohlsaum) unterscheiden sich deutlich im Preis,
   erklaert wurden sie bisher nur in der Produktbeschreibung. Neben der
   Ueberschrift "Saum" steht deshalb dasselbe kleine i-Icon wie bei der
   Stoffkombination auf den Wende-Seiten, dahinter ein Popup mit den drei
   Saumarten und ihren Massen.

   Warum eine eigene Datei und nicht direkt im Markup:
   Die Ueberschrift "Saum" wird von sections/pdp-main.liquid gerendert. Diese
   Datei ist rund 45 kB gross und laesst sich ueber die Theme-Files-API nicht
   zuverlaessig aendern, grosse Uploads werden dabei beschaedigt. Icon und Popup
   werden deshalb zur Laufzeit eingehaengt. Geladen wird die Datei aus
   snippets/pdp-fonts.liquid, genau wie assets/pdp-height.js und
   assets/pdp-stoff-info.js. Wer die Logik spaeter fest in die Section einbaut,
   loescht diese Datei und die Zeile im Snippet.

   Unterschied zu assets/pdp-stoff-info.js: Dort liefert assets/pdp-wende.css
   die Optik, die aber nur auf den Wende-Seiten geladen wird. Auf den
   Tischartikeln gibt es diese Datei nicht, deshalb bringt dieses Skript sein
   eigenes CSS mit (Praefix .pdp-saum-). Werte identisch zu pdp-wende.css.

   Ausgeloest wird es allein ueber die Variantenoption "Saum", nicht ueber
   Produkttyp oder Tag. Damit greift es automatisch auch bei kuenftigen
   Tischartikeln.

   Sichtbarkeit wie in assets/pdp-wende.js: das hidden-Attribut allein reicht im
   Focal-Theme nicht, weil Klassen mit display-Regel es schlagen. Deshalb wird
   display zusaetzlich gesetzt bzw. entfernt.
   ========================================================================== */
(function () {
  'use strict';

  var LABEL_MATCH = 'saum';

  var POPUP_HTML =
    '<div class="pdp-saum-popup" data-pdp-saum-popup hidden>' +
      '<div class="pdp-saum-popup__overlay" data-pdp-saum-popup-close></div>' +
      '<div class="pdp-saum-popup__card" role="dialog" aria-modal="true" aria-label="Die drei Saumarten">' +
        '<button type="button" class="pdp-saum-popup__close" data-pdp-saum-popup-close aria-label="Schließen">×</button>' +
        '<h3 class="pdp-saum-popup__title">Die drei Saumarten</h3>' +
        '<div class="pdp-saum-popup__text">' +
          '<p>Den Abschluss bestimmen Sie, die Wahl ist reine Stilfrage.</p>' +
          '<p><strong>Schmaler Saum mit Briefecken, ca.&nbsp;1&nbsp;cm:</strong> Schlichter, flach aufliegender Abschluss. Die Ecken sind auf Gehrung gearbeitet (diagonal auf Stoß gefaltet, wie die Rückseite eines Briefumschlags). Daher der Name Briefecke, und daher liegen die Ecken faltenfrei. Unser Klassiker für jeden Tag.</p>' +
          '<p><strong>Rahmensaum, ca.&nbsp;3,5&nbsp;cm (bei Servietten 40&nbsp;×&nbsp;40&nbsp;cm ca.&nbsp;2,5&nbsp;cm):</strong> Breiter umgeschlagener Saum, der die Tischwäsche sichtbar rahmt und dem Rand mehr Gewicht gibt.</p>' +
          '<p><strong>Rahmensaum mit Hohlsaum, in gleicher Breite:</strong> Derselbe breite Rahmen, zusätzlich mit Hohlsaum, einer durchbrochenen Ziernaht entlang der Kante. Das traditionelle Erkennungszeichen feiner Tischwäsche.</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  /* .pdp-size-head ist ein Flex-Container mit justify-content: space-between
     (siehe assets/pdp.css). Ein zweites Kind wuerde deshalb nach rechts rutschen.
     Label und Icon kommen darum in einen gemeinsamen Inline-Wrapper.
     align-items: center, damit der Kreis mittig zur Schrift sitzt. */
  function injectStyles() {
    if (document.getElementById('pdp-saum-info-styles')) return;
    var el = document.createElement('style');
    el.id = 'pdp-saum-info-styles';
    el.textContent = [
      '.pdp-saum-info-wrap{display:inline-flex;align-items:center;gap:6px;min-width:0;}',
      '.pdp-saum-info{display:inline-flex;align-items:center;justify-content:center;',
      'width:16px;height:16px;border-radius:50%;flex:0 0 16px;',
      'border:1px solid #B8860B;color:#B8860B;',
      'font-size:10px;font-style:italic;line-height:1;cursor:pointer;}',
      '.pdp-saum-info:hover{background:#B8860B;color:#fff;}',
      '.pdp-saum-popup{position:fixed;inset:0;z-index:1050;',
      'display:flex;align-items:center;justify-content:center;padding:20px;}',
      '.pdp-saum-popup[hidden]{display:none;}',
      '.pdp-saum-popup__overlay{position:absolute;inset:0;background:rgba(46,42,36,.55);}',
      '.pdp-saum-popup__card{position:relative;max-width:440px;width:100%;max-height:85vh;',
      'overflow-y:auto;padding:20px;border-radius:12px;background:#fff;}',
      '.pdp-saum-popup__close{position:absolute;top:8px;right:10px;border:0;background:none;',
      'font-size:24px;line-height:1;color:#6F675B;cursor:pointer;}',
      '.pdp-saum-popup__title{margin:0 0 12px;font-size:16px;font-weight:500;color:#2E2A24;}',
      '.pdp-saum-popup__text{font-size:13px;line-height:1.6;color:#2E2A24;}',
      '.pdp-saum-popup__text p{margin:0 0 10px;}',
      '.pdp-saum-popup__text p:last-child{margin-bottom:0;}',
      /* Die Saumart am Absatzanfang ist die Ueberschrift der Zeile. Sie ging
         mobil in der Textwand unter, deshalb eine Spur groesser und fetter. */
      '.pdp-saum-popup__text strong{font-size:14.5px;font-weight:600;}'
    ].join('');
    document.head.appendChild(el);
  }

  /* Sichtbarkeit exakt wie show() in assets/pdp-wende.js. */
  function show(el, on) {
    if (!el) return;
    el.removeAttribute('hidden');
    if (on) el.style.removeProperty('display');
    else el.style.setProperty('display', 'none', 'important');
  }

  /* Nur die Optionsueberschrift "Saum" selbst, nicht die Werte wie
     "Rahmensaum". Deshalb exakter Vergleich statt indexOf. */
  function findGroup(root) {
    var groups = root.querySelectorAll('.pdp-size-group');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.pdp-option-label');
      if (!label) continue;
      var txt = (label.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt === LABEL_MATCH) return groups[i];
    }
    return null;
  }

  function init() {
    if (window.__pdpSaumInfo) return;

    var root = document.querySelector('[data-pdp-main]');
    if (!root) return;

    var group = findGroup(root);
    if (!group) return;

    var head = group.querySelector('.pdp-size-head');
    if (!head) return;

    var label = head.querySelector('.pdp-option-label');
    if (!label) return;

    if (head.querySelector('[data-pdp-saum-info]')) return;

    window.__pdpSaumInfo = true;
    injectStyles();

    var trigger = document.createElement('span');
    trigger.className = 'pdp-saum-info';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('data-pdp-saum-info', '');
    trigger.setAttribute('aria-label', 'Was bedeuten die drei Saumarten?');
    trigger.textContent = 'i';

    var wrap = document.createElement('span');
    wrap.className = 'pdp-saum-info-wrap';
    if (label.parentNode) label.parentNode.insertBefore(wrap, label);
    wrap.appendChild(label);
    wrap.appendChild(trigger);

    var holder = document.createElement('div');
    holder.innerHTML = POPUP_HTML;
    var popup = holder.firstChild;
    if (!popup) return;
    document.body.appendChild(popup);

    /* Der Klick darf die darunterliegende Variantenauswahl nicht ausloesen. */
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      show(popup, true);
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        show(popup, true);
      }
    });

    var closers = popup.querySelectorAll('[data-pdp-saum-popup-close]');
    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        show(popup, false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      show(popup, false);
    });

    show(popup, false);
  }

  function boot() {
    try { init(); } catch (e) { /* nie die Buy-Box blockieren */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
